import { render, staticRenderFns } from "./team.vue?vue&type=template&id=a2cf26ee&scoped=true&lang=pug&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"
import style0 from "./team.vue?vue&type=style&index=0&id=a2cf26ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cf26ee",
  null
  
)

/* custom blocks */
import block0 from "~/lang/about?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230530095517%2Fpages%2Fabout%2Fteam.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230530095517/components/widgets/image.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230530095517/components/site/feefo.vue').default})
